import * as React from "react";
import {handleNavigation, RoutePaths} from "insurance/routes";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IProfile} from "StateInterface";
import {getInsuranceProducts} from "insurance/actions";

interface IConnectProps {
    dispatch?: (action: any) => void;
    profile: IProfile;
    userId: number;
}
interface IState {
    containerClass: string;
}
class PolicyTerms extends React.Component<IConnectProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            containerClass: null,
        };
    }
    public componentDidMount() {
        const containerClass = document.body.scrollHeight > screen.height ? "" : "add-padding";
        this.setState({containerClass});
    }
    public renderPolicyHeader() {
        return (
            <div className="policies-header">
                YOUR POLICY
            </div>
        );
    }
    public handleProceed = () => {
        this.props.dispatch(getInsuranceProducts());
        handleNavigation(RoutePaths.ACTIVE_INSURANCES);
    };
    public renderPolicyBody() {
        return (
            <div>
                <div className="policies-body">
                    <div className="small-text">Shubh Saathi - Accident Benefit Package</div>
                    <div className="small-text">for - <b style={{fontSize: 15}}>{this.props.profile.name}</b></div>
                    {this.renderPolicies()}
                    <div className="mt-3 text-center shubh-color"
                        onClick={this.handleProceed}
                    >
                        Okay
                    </div>
                </div>
                <div className={"text-center small-text pb-2 color-lightgray"}>Powered By <b>Good Health</b>.</div>
            </div>
        );
    }
    public renderPolicies() {
        return (
            <ul className="color-lightgray small-text mt-3 no-list-style text-left p-0">
                <li>
                    <i className="pr-1 float-left fa fa-check-circle shubh-color" aria-hidden="true"></i>
                    <p className="overflow-hidden">
                        This digital copy (pdf format) of this policy document is valid for all purposes.
                    </p>
                </li>
                <li>
                    <i className="pr-1 float-left fa fa-check-circle shubh-color" aria-hidden="true"></i>
                    <p className="overflow-hidden">
                        You can edit your policy in case of any errors.
                    </p>
                </li>
                <li>
                    <i className="pr-1 float-left fa fa-check-circle shubh-color" aria-hidden="true"></i>
                    <p className="overflow-hidden">
                        Package benefits valid for 1 year, as long as you are an employee of <b style={{color: "#000000"}}>{this.props.profile.currentEmployer}</b> and user of shubhloans app
                    </p>
                </li>
            </ul>
        );
    }
    public render() {
        return (
            <div className={`mt-4 ${this.state.containerClass}`}>
                <div className="insurance-card policies">
                    {this.renderPolicyHeader()}
                    {this.renderPolicyBody()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        profile: state.userform.userStatus ? state.userform.userStatus.profileStatus : null,
        userId: state.login ? state.login.auth.userId : null,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(PolicyTerms);
